import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    gap: theme.spacing(2),
    marginTop: theme.spacing(2)
  },
  backButton: {
    // backgroundColor: '#f8f8f8',
    color: theme.palette.primary.main
  },
  downloadButton: {
    // backgroundColor: theme.palette.error.main,
    color: 'white'
  }
}))
